import React, { Fragment } from 'react';
import { translate } from '../Services/translation';

const ConfiguratorOptionInfo = ({ infoArticle, infoSection, traverseArticles, select, showArticleInfo }) => (
    (<Fragment>
        {infoArticle &&
            <div className="configurator-options-left__close-outside" onClick={() => showArticleInfo(null, null)} ></div>
        }
        <div className="configurator-options__left">
            <a className="configurator-options__close" onClick={() => showArticleInfo(null, null)}>
                <svg>
                    <use href="/ui/images/tibergs-svg/sprite/sprite.svg#close"></use>
                </svg>
            </a>
            <div className="configurator-info">
                {infoArticle &&
                    <ArticleInfo option={infoArticle} section={infoSection} select={select} traverseArticles={traverseArticles} />
                }
            </div>
        </div>
    </Fragment>))

const ArticleInfo = ({ option, section, select, traverseArticles }) => (
    <div className={((option.imageData && option.imageData.src) ? "" : "configurator-vertical-align")} >
        <div className="configurator-info__inner">
            {(option.imageData && option.imageData.src) ?
                (
                    <div>
                        <div className="configurator-info__image-container">
                            <Controls traverseArticles={traverseArticles}></Controls>
                            <div className="configurator-info__image-wrapper">
                                <img className="configurator-info__image" alt={option.imageData.alt} src={option.imageData.src} />                                
                                {option.imageData.logosrc && <img className="configurator-info__logo" src={option.imageData.logosrc} alt={option.imageData.alt}/>}
                            </div>
                        </div>
                        <Configuratorinfotitle select={select} option={option} section={section} ></Configuratorinfotitle>
                    </div>
                ) : (<div className="no-image-info_title-wrap" >
                    <Controls traverseArticles={traverseArticles}></Controls>
                    <Configuratorinfotitle select={select} option={option} section={section} ></Configuratorinfotitle>
                </div>

                )}

            <div className={`configurator-info__option-heading ${(option.imageData && option.imageData.src) ? "" : "no-image-option-heading"}`} >               
              {(option.custom) ?
                (
                    <h4>{option.customName}</h4>
                ) : (
                    option.additionalInfo && option.additionalInfo.row2 && 
                    <h4>{option.additionalInfo.row2}</h4>
                )}
                {option.moreInfoLink && <a className="configurator-info__select ti-btn ti-btn--beige" target="_blank" href={option.moreInfoLink}>{option.moreInfoText}</a>}
            </div>
            <div className={(option.imageData && option.imageData.src) ? "" : "no-image-option-heading"} dangerouslySetInnerHTML={{ __html: option.editor }} />
        </div>
    </div>
)

const Controls = ({ traverseArticles }) => (<Fragment>
    <a className="configurator-info__control configurator-info__control--next" onClick={() => traverseArticles(1)}>
        <svg>
            <use href="/ui/images/tibergs-svg/sprite/sprite.svg#arrow-right"></use>
        </svg>
    </a>
    <a className="configurator-info__control configurator-info__control--prev" onClick={() => traverseArticles(-1)}>
        <svg>
            <use href="/ui/images/tibergs-svg/sprite/sprite.svg#arrow-right"></use>
        </svg>
    </a>
</Fragment>)


const Configuratorinfotitle = ({ option, section, select }) => {
    return <h4 className="configurator-info__title">
        {option.name}
        {(!section.userSelected || !option.selected) &&
            <a className="configurator-info__select ti-btn" onClick={() => { select(option) }}>{translate('configurator.select')}</a>
        }
        {section.userSelected && option.selected &&
            <span className="configurator-info__select ti-btn ti-btn--disabled">{translate('configurator.selected')}</span>
        }
    </h4>

}


export default ConfiguratorOptionInfo;
